module.exports = __webpack_public_path__ + "static/media/blank-disc.d414020f.png";